var React = require('react');
var Extras = require('../../../data/extras.json');
var Frame = require('../../views/Frame');

var createSprite = require('../../../lib/createSprite');
var spritesHelper = require('../../../lib/spritesHelper');
var Utils = require('../../../lib/utils');
var Audio = require('../../../lib/audio');

var CommonAnimations = require('../../../animations/common');

var BucketAnalyser = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        backgroundKey: React.PropTypes.string,
        movieclipKey: React.PropTypes.string
    },

    contextTypes: {
        minIntensity: React.PropTypes.number,
        maxIntensity: React.PropTypes.number,
        language: React.PropTypes.string,
    },

    timeline: null,
    sprites: null,
    pixiFlux: null,
    audios: null,
    movieclipTimelines: null,

    getDefaultProps: function()
    {
        return {
            texts: [
                {
                    title: 'Julie RANDALL',
                    subtitle: 'Contrôleure chef\nsection finances',
                    opts: {
                        align: 'right',
                        x: 1010,
                        y: 150
                    }
                }
            ],
            className: 'bucket-analyser',
            backgroundKey: 'bucketAnalyserBg',
            movieclipKey: 'magnifierGirl',
            fluxSettings: require('../../../flux/bucketAnalyser'),
            audioUrls: {
                flux: ['/audio/28nov/general-liquide-mouv-01.ogg', '/audio/28nov/general-liquide-mouv-01.mp3'],
            },
            // The keys for the extra texts
            title: 'julie',
            role: 'julie_title',
        }
    },

    render: function()
    {
        const texts = _.merge(this.props.texts, [
            {
                title: Extras[this.props.title].text[this.context.language],
                subtitle: Extras[this.props.role].text[this.context.language],
            },
        ]);

        return (
            <Frame
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onIntensityChanged={this.updateIntensity}
                {...this.props}
            />
        );
    },

    build: function(container, timeline, opts)
    {
        this.sprites = {
            container: container
        };
        this.timeline = timeline;
        this.pixiFlux = opts.pixiFlux;

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key){
            this.audios[key] = new Audio(value, {
                loop: true,
                channel: 'frame'
            });
        }, this));

        this.buildObjects();
        this.animateObjects();
    },

    play: function()
    {
        if (this.audios.flux) {
            this.audios.flux.fadeInFast();
        }
    },

    pause: function()
    {
        if (this.audios.flux) {
            this.audios.flux.fadeOutFast();
        }
    },

    destroy: function()
    {
        if (this.audios.flux) {
            this.audios.flux.destroy();
        }

        if (this.timeline) {
            this.timeline.kill();
            this.timeline = null;
        }

        console.log('julie sprites', this.sprites);

        if (this.sprites) {
            Object.keys(this.sprites).forEach(key => (
                TweenMax.killTweensOf(this.sprites[key])
            ));
        }

        this.sprites = null;
        this.audios = null;
        this.movieclipTimelines = null;
    },

    buildObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;
        var objs = props.objs;
        var container = sprites.container;

        var i, movieclipProp, movieclipObject, movieclip;

        // DIPLOME
        var diplomeObj = objs.diplomeBucketAnalyser;
        var diplome = sprites.diplome = createSprite(diplomeObj);
        Utils.setSizeAndPositionFromRefSize(diplome, props.width, props.height, diplomeObj);
        container.addChild(diplome);

        // flux
        var fluxMask = spritesHelper.createFrameMaskFromSize(props.width, props.height * 0.86);
        var fluxContainer = new PIXI.Container();
        fluxContainer.mask = fluxMask;
        if (this.pixiFlux)
        {
            this.pixiFlux.setContainer(fluxContainer, props.width);
        }

        // magnifierGirl - intensity-related movieclip
        for (i = minIntensity; i <= maxIntensity; i++)
        {
            movieclipProp = props.movieclipKey+i;
            movieclipObject = objs[movieclipProp];
            movieclip = sprites[movieclipProp] = createSprite(movieclipObject);
            Utils.setSizeAndPositionFromRefSize(movieclip, props.width, props.height, movieclipObject);
            movieclip.mask = fluxMask;
            movieclip.userData = {character: true};
            container.addChild(movieclip);
        }

        container.addChild(fluxContainer);
        container.addChild(fluxMask);
    },

    animateObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var objects = props.objs;

        var timeline = this.timeline;

        var movieclipTimelines = this.movieclipTimelines = [];

        // intensities-influenced movieclips
        var i, movieclipProp, movieclip, movieclipObject, intensityMovieclips;
        [props.movieclipKey].map(_.bind(function(intensityMovieclipKey, intensityMovieclipIndex){
            var intensityMovieclips = [];
            for (i = context.minIntensity; i <= context.maxIntensity; i++)
            {
                movieclipProp = intensityMovieclipKey+i;
                movieclip = sprites[movieclipProp];
                movieclipObject = objects[movieclipProp];
                movieclip.name = intensityMovieclipKey+i;
                intensityMovieclips.push(movieclip);
            }
            movieclipTimelines.push(timeline.add(CommonAnimations.getMovieclipTimeline(intensityMovieclips, {
                fps: 4
            }), intensityMovieclipIndex * 0.1));
        }, this));

        if (this.props.onAnimationReady)
        {
            this.props.onAnimationReady(timeline);
        }
    },

    updateIntensity: function(prevIntensity)
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;

        var intensity = props.intensity;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;

        prevIntensity = typeof prevIntensity !== 'undefined' ? prevIntensity: intensity;

        // movieclip timelines
        _.each(this.movieclipTimelines, function(movieclipTimeline){
            movieclipTimeline.timeScale(1 + (intensity-2) * 0.15);
        });

        // intensity-influenced movieclips
        [props.movieclipKey].map(function(intensityMovieclipKey)
        {
            for (var i = minIntensity; i <= maxIntensity; i++)
            {
                var movieclip = sprites[intensityMovieclipKey+i];
                movieclip.visible = i === intensity;
            }
        });
    }
});

module.exports = BucketAnalyser;



// WEBPACK FOOTER //
// ./js/components/frames/D-Regulation/7-BucketAnalyser.jsx